$(document).ready(function () {

  const faqQuestions = document.querySelectorAll('.v-togttl');
  faqQuestions.forEach(question => {
      question.addEventListener('click', () => {
          faqQuestions.forEach(item => {
              if (item !== question) {
                  item.classList.remove('active'); // Remove 'active' class to reset arrow rotation
                  item.nextElementSibling.style.maxHeight = null; // Collapse the answer
              }
          });
          question.classList.toggle('active');
          const answer = question.nextElementSibling;
          if (answer.style.maxHeight) {
              answer.style.maxHeight = null;
          } else {
              answer.style.maxHeight = answer.scrollHeight + 'px';
          }
      });
  });

});   

document.addEventListener("click", function (e) {
//console.log('product click btn reddy1');
  if (e.target.closest("#wfq_inject_wish_button")) {

    //console.log("Button clicked");

    const observer = new MutationObserver(function () {

      var textarea = document.querySelector('#wfq-modal .wfq_message textarea');

      if (textarea) {
        //console.log("Textarea found");

        textarea.placeholder = "Describe your arm cover requirement (e.g., Size, Type, Material )";
        //console.log('product click btn reddy2');
        // Stop observing once done
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

});

jQuery(document).ready(function() {
    //console.log('product click btn reddy0p');
});	
